export class ScholarshipServiceDataNotFoundError extends Error {
	public constructor() {
		super('The requested data could not be found');
	}
}
